import Env from '../base/env.js'
import axios from 'axios'

export default class MailSender
{
    constructor(_view)
    {
      this.view = _view
      this.$form = this.view.querySelector('.jsForm--view');
      this.$inputs = this.view.querySelectorAll('.jsFieldCheck')
      this.$callbacksFields = this.view.querySelectorAll('.cbs')
      this.$fields = document.querySelectorAll('.jsField')
      if(this.$form == null) return false;
      this.events()
    }

    events()
    {
      this.$form.addEventListener('submit',(event)=> {
        if(!this.$form.classList.contains('for--success') && !this.$form.classList.contains('for--error') && !this.$form.classList.contains('for--loading'))
        {
            this.send()
        }
        event.preventDefault();
      })

      for(let $input of this.$inputs) {
        const tagName = $input.tagName
        if(tagName == 'INPUT' || tagName == 'TEXTAREA') {
          $input.addEventListener('change',()=>{
            if($input.value != '') {
              $input.classList.add('is--filled')
            } else {
              $input.classList.remove('is--filled')
            }
          })
        }
        if(tagName == 'SELECT') {
          $input.addEventListener('change',()=>{
            if($input.value == '-' || $input.value == '') {
              $input.parentElement.classList.remove('is--filled')
            } else {
              $input.parentElement.classList.add('is--filled')
            }
          })
        }
      }
    }


    ok()
    {
      this.$form.classList.add('for--success');
    }

    resetCallbackFields()
    {
      for(let i = 0; i < this.$callbacksFields.length; i++){
        const $callbackField = this.$callbacksFields[i]
        $callbackField.classList.remove('has--error')
        $callbackField.innerHTML = ''
      }
    }

    resetFields()
    {
      for(let i = 0; i < this.$fields.length; i++){
        const $field = this.$fields[i]
        $field.classList.remove('has--error')
      }
    }

    send()
    {
      let formDatas = new FormData(this.$form)
      this.$form.classList.remove('for--success')
      this.$form.classList.remove('for--error')
      this.$form.classList.remove('for--loading')
      this.$form.classList.add('for--loading')

      axios({
        method: "post",
        url: this.$form.getAttribute('action'),
        data: formDatas,
        responseType : 'json',
      }).then((_response)=>{
        this.$form.classList.remove('for--loading')
        this.resetFields();
        this.resetCallbackFields()
        for(let $key of Object.keys(_response.data.messages)){
            const $text = _response.data.messages[$key]
            const $element = document.querySelector(`.cb-${$key}`)
            if($element != null) {
              $element.innerHTML = $text
            }
        }
        if(_response.data.success)
        {
            this.ok();
        }
      })
    }
}
